import styled from 'styled-components';

import Throbber from '@r1-frontend/ui-react/components/loaders/Throbber';
import { BorderRadius } from '@r1-frontend/ui-react/tokens/borderRadius';

export const BgThrobber = styled(Throbber)`
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    background-color: rgba(0,0,0,0.1);
    border-radius: ${BorderRadius.OuterBlockRadius};
`;
